
  export default {
    props: {
      physicianSpecialties: Array,
      language: String
    },
    data() {
      return {
        resultsPerPage: 10,
        pageNumber: 1,
        physicians: [],
        filterFields: {
          specialty: '',
          firstName: '',
          lastName: '',
          cityOrZip: '',
          ncpsOnly: false,
        },
        filterApplied: {
          specialty: '',
          firstName: '',
          lastName: '',
          cityOrZip: '',
          ncpsOnly: false,
        },
        loading: true
      }
    },
    computed: {
      filteredPhysicians() {
        let results = this.physicians
        
        if (this.filterApplied.specialty) {
          results = results.filter(p => p.specialties.some(s => s.id === this.filterApplied.specialty))
        }

        if (this.filterApplied.firstName) {
          results = results.filter(p => p.firstName.toLowerCase().includes(this.filterApplied.firstName.toLowerCase()))
        }

        if (this.filterApplied.lastName) {
          results = results.filter(p => p.lastName.toLowerCase().includes(this.filterApplied.lastName.toLowerCase()))
        }

        if (this.filterApplied.cityOrZip) {
          results = results.filter(p =>
            p.primaryOffice 
            && p.primaryOffice.city
            && p.primaryOffice.zipCode
            && ((p.primaryOffice.city + p.primaryOffice.zipCode).toLowerCase().includes(this.filterApplied.cityOrZip.toLowerCase()))
          )
        }

        if (this.filterApplied.ncpsOnly) {
          results = results.filter(p => p.ncps)
        }

        return results
      },
      paginatedPhysicians() {
        return this.filteredPhysicians.slice((this.pageNumber - 1) * this.resultsPerPage, this.pageNumber * this.resultsPerPage)
      },
      maxPageNumber() {
        return Math.ceil(this.filteredPhysicians.length / this.resultsPerPage)
      },
      validPhysicianSpecialties() {
        // Filter physician specialties to those assigned to at least one physician
        return this.physicianSpecialties.filter(s => this.physicians.some(p => p.specialties.some(sp => sp.id === s.id)))
      }
    },
    mounted() {
      this.fetchPhysicians(this.language)
    },
    methods: {
      fetchPhysicians(language) {
        fetch(`/webapi/physiciansapi/physicians/${language}`)
          .then(response => response.json())
          .then(json => {
            this.loading = false
            this.physicians = json
            this.applyQueryStringToFilters()
            this.search()
          })
      },
      search(e) {
        if (e) e.preventDefault();
        this.pageNumber = 1;
        this.filterApplied = {
          specialty: this.filterFields.specialty,
          firstName: this.filterFields.firstName,
          lastName: this.filterFields.lastName,
          cityOrZip: this.filterFields.cityOrZip,
          ncpsOnly: this.filterFields.ncpsOnly,
        }
        this.setQueryString()
      },
      previousPage() {
        this.pageNumber -= 1
      },
      nextPage() {
        this.pageNumber += 1
      },
      loadMore() {
        this.displayCount = Number.MAX_SAFE_INTEGER
      },
      setQueryString() {
        let url = new URL(window.location.href)
        
        Object.keys(this.filterFields).forEach(key => {
          url.searchParams.delete(key)
          if (this.filterFields[key]) {
            url.searchParams.set(key, this.filterFields[key])
          }
        })

        window.history.pushState(null, '', url.toString())
      },
      applyQueryStringToFilters() {
        let queryString = new URLSearchParams(window.location.search)

        Object.keys(this.filterFields).forEach(key => {
          if (queryString.has(key)) {
            this.filterFields[key] = queryString.get(key)
          }
        })

        this.filterFields.ncpsOnly = (queryString.get('ncpsOnly') == 'true')
      }
    }
  }
